/* This file is autogenerated, see readme.md for instructions */
import CloseSmallSvgIcon from '@bloomreach/banana-theme/icons/close-small.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CloseSmallIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CloseSmallSvgIcon />
    </Icon>
  );
});

CloseSmallIcon.displayName = 'CloseSmallIcon';

export default CloseSmallIcon;
